/* eslint-disable react/display-name */
import AddIcon from "@mui/icons-material/Add";
import AddBox from "@mui/icons-material/AddBox";
import ArrowDownward from "@mui/icons-material/ArrowDownward";
import Check from "@mui/icons-material/Check";
import ChevronLeft from "@mui/icons-material/ChevronLeft";
import ChevronRight from "@mui/icons-material/ChevronRight";
import Clear from "@mui/icons-material/Clear";
import DeleteOutline from "@mui/icons-material/DeleteOutline";
import Edit from "@mui/icons-material/Edit";
import FilterList from "@mui/icons-material/FilterList";
import FirstPage from "@mui/icons-material/FirstPage";
import LastPage from "@mui/icons-material/LastPage";
import Remove from "@mui/icons-material/Remove";
import SaveAlt from "@mui/icons-material/SaveAlt";
import Search from "@mui/icons-material/Search";
import ViewColumn from "@mui/icons-material/ViewColumn";
import db from "../../db/db";
import MaterialTable from "@material-table/core";
import React, { forwardRef, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../utils/API";
import CategoryCrud from "./CategoryCrud.jsx";
import { Typography } from "@mui/material";

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

export default function CategoryList(props) {
  console.log("propszzzz", props.context.privileges.category_edit);
  const { t } = useTranslation();
  const translate = t;
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [searchStr, setSearchStr] = useState("");
  const [treeData, setTreeData] = useState("");

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  useEffect(() => {
    loadData();
  }, []);

  var biRef = {};

  async function loadData() {
    loadByRest();
    //loaadByDB();
  }

  async function loadByRest() {
    setTreeData([]);
    setIsLoading(true);
    const result = await API.get("/api/v1/categoriesAsTree");
    setTreeData(result.data);
    /* var arr = result.headers["content-range"].split("/");

    const opt = { ...option };
    opt.count = parseInt(arr[2]);
    setOption(opt);
    setData(result.data);
    setIsLoading(false);*/
  }

  async function loaadByDB() {
    db.accountingsettings.toArray(function (data) {
      setData(data);
    });
  }
  function categoryListRefresh() {
    loadData();
  }

  function addCategory(id, level) {
    biRef.deptChild.showCategoryCrudWindow(id, level, "create");
  }
  function onEditClicked(id, level) {
    if (level == 0)
      biRef.deptChild.showCategoryCrudWindow(
        id,
        null,
        props.context.privileges.category_edit ||
          props.context.privileges.category_delete
          ? "edit"
          : "view"
      );
    else
      biRef.deptChild.showCategoryCrudWindow(
        id,
        Number(level) - 1,
        props.context.privileges.category_edit ||
          props.context.privileges.category_delete
          ? "edit"
          : "view"
      );
  }
  let actions = [];
  if (props.context.store.shopType != "BRANCH") {
    actions.push(
      (rowData) => ({
        icon: () => (
          <Typography variant="body1" color="secondary">
            <b>
              {props.context.privileges.category_edit
                ? translate("EDIT")
                : translate("VIEW")}
            </b>
          </Typography>
        ),
        // <Edit style={{ color: "primary", marginRight: 20 }} />
        // iconProps: { color: "primary" },
        // tooltip:
        //   Number(rowData.level) == 0
        //     ? translate("Edit Department")
        //     : Number(rowData.level) == 1
        //     ? translate("Edit Sub Department")
        //     : Number(rowData.level) == 2
        //     ? translate("Edit Category")
        //     : translate("Edit Sub Category"),
        onClick: (event, rowData) => {
          onEditClicked(rowData.id, rowData.level);
        },
        hidden: rowData.id == "root" ? true : false,
      }),
      (rowData) => ({
        icon: () => <AddIcon style={{ color: "red" }} />,
        tooltip:
          Number(rowData.level) == 0
            ? translate("Add New Sub Category")
            : Number(rowData.level) == 1
            ? translate("Add Category")
            : translate("Add Sub Category"),
        onClick: (event, rowData) => addCategory(rowData.id, rowData.level),
        hidden: Number(rowData.level) == 3 ? true : false,
      }),
      {
        icon: () => <AddIcon style={{ color: "blue" }} />,
        tooltip: translate("Add New Category"),
        isFreeAction: true,

        onClick: (e) => addCategory(null, null),
      }
    );
  }
  return (
    <div>
      <CategoryCrud
        biRef={biRef}
        onRefresh={categoryListRefresh}
        showMessage={props.showMessage}
        context={props.context}
      ></CategoryCrud>
      <MaterialTable
        icons={tableIcons}
        title={translate("Category List")}
        data={treeData}
        columns={[
          {
            title: translate("Name"),
            field: "name",
            cellStyle: (rowDataArray, rowData) => {
              const paddingLeft = 25 * Number(rowData.level);
              return { paddingLeft: paddingLeft, width: "35%" };
            },
          },
          { title: translate("Code"), field: "code", align: "left" },
          {
            title: translate("Level"),
            field: "level",
            align: "left",
            render: (rowData) => {
              return Number(rowData.level) == 0
                ? translate("Department")
                : Number(rowData.level) == 1
                ? translate("Sub Department")
                : Number(rowData.level) == 2
                ? translate("Category")
                : translate("Sub Category");
            },
          },
        ]}
        actions={actions}
        parentChildData={(row, rows) => rows.find((a) => a.id === row.parentId)}
        options={{
          paging: false,
          maxBodyHeight: getWindowDimensions().height - 175,
          actionsColumnIndex: 5,
        }}
      />
    </div>
  );
}
